
  /*
    Show/hide the recover password form when requested.
  */
    function showRecoverPasswordForm() {
        document.getElementById('recover_password').style.display = 'block';
        document.getElementById('customer_login').style.display='none';
      }
    
      function hideRecoverPasswordForm() {
        document.getElementById('recover_password').style.display = 'none';
        document.getElementById('customer_login').style.display = 'block';
      }
    
      // Allow deep linking to the recover password form
      if (window.location.hash == '#recover') { showRecoverPasswordForm() }